<template>
  <div class="w-88px h-31px border-0.5px cursor-pointer">
    <p class="font-jeju-myeongjo font-normal text-[26px] text-textPrimary">
      Episod_
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      screenWidth: window.innerWidth,
    }
  },
  computed: {
    isMobile() {
      return this.screenWidth < 660
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.screenWidth = window.innerWidth
    },
  },
}
</script>
